module.exports = __webpack_public_path__ + "media/img/pages/companies/axpo-new-21ccf565ee66ed4d8d71ce56fabbfb81.png";